module.exports = __webpack_public_path__ + "img/img07.72c748fe.jpeg";